import { render, staticRenderFns } from "./templateDetailsDialog.vue?vue&type=template&id=044287c9&"
import script from "./templateDetailsDialog.vue?vue&type=script&lang=js&"
export * from "./templateDetailsDialog.vue?vue&type=script&lang=js&"
import style0 from "./templateDetailsDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports